import { render, staticRenderFns } from "./acctManagerDc.vue?vue&type=template&id=c497ccd0&scoped=true"
import script from "./acctManagerDc.vue?vue&type=script&lang=js"
export * from "./acctManagerDc.vue?vue&type=script&lang=js"
import style0 from "./acctManagerDc.vue?vue&type=style&index=0&id=c497ccd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c497ccd0",
  null
  
)

export default component.exports